import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  InputNumber,
  Modal,
  Row,
  Select,
} from "antd";
import React, { useRef, useState } from "react";
import { useClient } from "../../../Context/ClientContext";
import { DeleteOutlined } from "@ant-design/icons";
import { Utils } from "../../../../Utilities/Utils";
import { dayjs } from "../../../../Utilities/dayjs";
import { CalcMethod } from "../../../Services/FixedAssetsServiceNew";

const calculateDepreciation = (
  disDate: any, // VoucherDate
  rate: any, //  depRate
  price: any, // Qty * Purchase Price
  method: CalcMethod, // depMethod
  residualValue: any, // itemDetail.residualValue
  startDate: any, // itemDetail.depreciationStartDate
  lastDepDate: any, // itemDetail.lastDepreciationDate - null all
  accumulatedDep: any, // accumulatedDepreciation
  year: any, // -  lifeCycleDuration
  isDepreciableAsset: boolean, // isDepreciable - isDepreciable
  selAssetNumber?: string // ??
) => {
  let depreciation = 0;
  let leapyear = false;
  if (isDepreciableAsset) {
    const date1 =
      dayjs(lastDepDate).unix() > 1
        ? dayjs(lastDepDate, "YYYY/MM/DD")
        : dayjs(startDate, "YYYY/MM/DD");
    const date2 = dayjs(disDate, "DD/MM/YYYY");
    leapyear = date1.year() % 4 === 0 ? true : false;
    let yeardays = leapyear ? 366 : 365;
    let days =
      date2.diff(date1, "day") < 0
        ? 0
        : date2.diff(date1, "day") + (leapyear ? 1 : 0);
    // if (!lastDepDate || accumulatedDep === 0) days++;
    let calcPrice = price - accumulatedDep;
    if (method === CalcMethod.WrittenDownValue) {
      depreciation = (calcPrice * (rate / 100) * days) / yeardays;
    } else {
      depreciation = (((price - residualValue) / year) * days) / yeardays;
      if (depreciation > calcPrice) {
        depreciation = calcPrice > 0 ? calcPrice : 0;
      }
    }
  }
  return depreciation;
};

const SelectDisposeAssetItem: React.FC<{
  open: boolean;
  onCancel: any;
  isLocked: boolean;
  itemIndex: number;
  itemData: any;
  saveIndexAssetItems: any;
  voucherDate: string;
  updateId: string | undefined;
  // selectedInvDetail: any;

  // id: any;
  //   setInInvoice: (parma: any) => void;
  //   setBatchItmName: (parma: any) => void;
  //   setForAddSerialData: (parma: any) => void;
  //   setSerial: (parma: any) => void;
  //   serial: any;
  //   setTriggerSerialData: any;
  //   inputFieldNull: () => void;
  //   alReadySelectedData: any;
  //   forAddSerialData: any;
  //   selectedBatchData: any;
  //   setSelectedBatchData: any;
}> = (props) => {
  const autoCompleteRef = useRef<any>(null);
  const { currentClient } = useClient();
  const [form] = Form.useForm();
  const [currentItemData, setCurrentItemData] = useState<any[]>(
    props?.itemData?.allAssetInvDetail
  );
  const [selectDepInvDetail, setSelectDepInvDetail] = useState<string[]>([]);
  const [footerTotal, setFooterTotal] = useState<{
    qty: number;
    amount: number;
  }>({
    qty: 0,
    amount: 0,
  });
  const [trigger, setTrigger] = useState<number>(0);

  React.useEffect(() => {
    setTrigger(0);

    if (props?.itemData?.selectedInvDetail?.length > 0) {
      const data = props?.itemData?.selectedInvDetail.map(
        (x: any, index: number) => {
          setSelectDepInvDetail((prevState) => {
            const updatedSelectedOptions = [...prevState];
            updatedSelectedOptions[index] = x?.id;
            return updatedSelectedOptions;
          });
          return {
            ...x,
            date: dayjs(dayjs(x?.date)?.format("DD/MM/YYYY"), "DD/MM/YYYY"),
          };
        }
      );

      form.setFieldValue("items", data);
      setFooterTotal({
        qty: props.itemData?.amount?.qty,
        amount: props.itemData?.amount?.price,
      });
    }
    setTrigger((x) => x + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.itemData]);

  const itemSelect: any = async (value: string, index: number) => {
    const selectedItem = currentItemData?.find(
      (Item: any) => Item?.id === value
    );
    if (selectedItem) {
      const itemData = {
        voucherRef: {
          label: selectedItem?.voucherRef?.name,
          value: selectedItem?.id,
        },
        date: dayjs(
          dayjs(selectedItem?.date)?.format("DD/MM/YYYY"),
          "DD/MM/YYYY"
        ),
        availableQty: selectedItem?.availableQty,
        purchasePrice: selectedItem?.price,
        // qty: selectedItem?.qty,
      };

      form.setFieldValue(["items", index], itemData);
      setSelectDepInvDetail((prevState) => {
        const updatedSelectedOptions = [...prevState];
        updatedSelectedOptions[index] = value;
        return updatedSelectedOptions;
      });
    }
  };

  const handleAllTheTotalValues = () => {
    const itemList = form.getFieldValue(["items"]);

    //------- Total Row Calculations -------
    const Total = itemList?.reduce(
      (
        acc: {
          TotalQty: number;
          TotalAmount: number;
        },
        curr: any
      ) => {
        acc.TotalQty += qty(curr);
        // acc.TotalUnitPrice += price(curr);
        acc.TotalAmount += amountInNumber(curr, "totalAmount");
        return acc;
      },
      {
        TotalQty: 0,
        TotalAmount: 0,
      }
    );
    setFooterTotal({
      qty: Total.TotalQty,
      amount: Total.TotalAmount,
    });
  };

  const amountInNumber = (val: any, key: any) => {
    return Utils.getNumber(val?.[key]);
  };
  const price = (curr: any) => amountInNumber(curr, "sellPrice");
  const qty = (curr: any) => amountInNumber(curr, "qty");
  const netAmount = (curr: any) => price(curr) * qty(curr);

  // on change in items files amount chnage
  const handleItemsNetAmmount = (index: number) => {
    // debugger;
    const currentIndexData = form.getFieldValue(["items", index]);

    if (currentIndexData) {
      // console.log("currentIndexData", currentIndexData, currentItemData);
      const totalSaleAmt: number = netAmount(currentIndexData);
      const item = currentItemData?.find(
        (x) => x.id === currentIndexData?.voucherRef?.value
      );
      const totalAccuAmt = currentIndexData.qty * item.accumulatedDepreciation;
      const totalPurAmt = currentIndexData.qty * currentIndexData.purchasePrice;
      const totalResidualValue =
        currentIndexData.qty * (item?.itemDetail?.residualValue || 0);
      const wdvValue = totalPurAmt - totalAccuAmt;
      const totalDepreciation = calculateDepreciation(
        props.voucherDate,
        props?.itemData?.otherDetails?.depRate,
        totalPurAmt,
        props?.itemData?.otherDetails?.depMethod,
        totalResidualValue,
        item?.itemDetail?.depreciationStartDate,
        item?.itemDetail?.lastDepreciationDate,
        totalAccuAmt,
        props?.itemData?.otherDetails?.lifeCycleDuration,
        props?.itemData?.otherDetails?.isDepreciable
        // currentIndexData?.voucherRef?.label
      );
      const pnLAmt = wdvValue - totalDepreciation - totalSaleAmt;
      form.setFieldValue(["items", index], {
        ...currentIndexData,
        totalAmount: totalSaleAmt,
        depreciationsAmt: Utils.getFormattedNumber(totalDepreciation),
        pAndLAmt: Utils.getFormattedNumber(-pnLAmt),
      });
      // console.log("currentIndexData", item, totalDepreciation);
    }

    handleAllTheTotalValues();
    // addTotalTaxAmountChange(currentIndexData);
  };

  const onItemsTotalAmountChange = (index: number, totalPrice: number) => {
    const currentIndexData = form.getFieldValue(["items", index]);
    if (currentIndexData) {
      const item = currentItemData.find(
        (x) => (x.id = currentIndexData?.voucherRef?.value)
      );
      const totalAccuAmt = currentIndexData.qty * item.accumulatedDepreciation;
      const totalPurAmt = currentIndexData.qty * currentIndexData.purchasePrice;
      const totalResidualValue =
        currentIndexData.qty * (item?.itemDetail?.residualValue || 0);
      const wdvValue = totalPurAmt - totalAccuAmt;
      const totalDepreciation = calculateDepreciation(
        props.voucherDate,
        props?.itemData?.otherDetails?.depRate,
        totalPurAmt,
        props?.itemData?.otherDetails?.depMethod,
        totalResidualValue,
        item?.itemDetail?.depreciationStartDate,
        item?.itemDetail?.lastDepreciationDate,
        totalAccuAmt,
        props?.itemData?.otherDetails?.lifeCycleDuration,
        props?.itemData?.otherDetails?.isDepreciable
        // currentIndexData?.voucherRef?.label
      );
      const pnLAmt = wdvValue - totalDepreciation - totalPrice;
      form.setFieldValue(["items", index], {
        ...currentIndexData,
        sellPrice:
          amountInNumber(currentIndexData, "totalAmount") /
          qty(currentIndexData),
        depreciationsAmt: Utils.getFormattedNumber(totalDepreciation),
        pAndLAmt: Utils.getFormattedNumber(-pnLAmt),
      });
    }
    handleAllTheTotalValues();
  };

  // Post Dispose Asset Item Save
  const postData = () => {
    form.validateFields().then(async (value) => {
      const postData = value?.items?.map((x: any) => {
        return {
          ...x,
          id: x?.voucherRef?.value,
          name: x?.voucherRef?.label,
          value: x?.sellPrice,
          date: x?.date ? dayjs(x?.date).toISOString() : undefined,
        };
      });

      props.saveIndexAssetItems({
        index: props.itemIndex,
        selectedInvDetail: postData,
        footerTotal: footerTotal,
      });
      props.onCancel();
      console.log(value);
    });
  };

  return (
    <Modal
      open={props.open}
      maskClosable={false}
      title={`Disposed Item  - ${props.itemData?.id?.label} `}
      width={1200}
      onCancel={() => props.onCancel()}
      style={{ maxHeight: `calc(100% - 100px)`, overflowY: "auto", top: 180 }}
      footer={
        <div style={{ marginTop: "0px" }}>
          <Button
            onClick={() => {
              form.resetFields();
              props.onCancel();
            }}
          >
            Cancel
          </Button>
          <Button
            className="modelSaveButtonMargin"
            type="primary"
            onClick={() => postData()}
            // loading={saveButtonLoading}
          >
            {/* {!props?.data.id ? "Save" : "Update"} */}
            Save
          </Button>
        </div>
      }
    >
      <Divider className="ca-model-css" />
      <Form
        form={form}
        initialValues={{
          items: [{}],
        }}
        //   onValuesChange={handleChange}
      >
        <table className="AddPageTabelDesign" style={{ width: "100%" }}>
          <thead>
            <tr>
              <th>Select Asset Item</th>
              <th>Voucher Date</th>
              {/* <th>Expiry Date</th> */}

              <th>Available Qty.</th>
              <th>Purchase Price</th>
              <th>Qty.</th>
              <th>Sales Price</th>
              <th>Total Price</th>
              <th>Depreciations</th>
              <th colSpan={2}>P&L Amt</th>
            </tr>
          </thead>

          <tbody>
            <Form.List name="items">
              {(fields, { add, remove }) => {
                return (
                  <>
                    {fields.map(({ key, name, ...restField }, index) => {
                      return (
                        <tr key={key}>
                          {/* Select Asset Item */}
                          <td style={{ width: "20%" }}>
                            <Form.Item
                              name={[name, "voucherRef"]}
                              className="m-0"
                            >
                              <Select
                                labelInValue
                                placeholder="Select item"
                                onChange={(x: any) => {
                                  if (fields.length === index + 1) add();
                                  itemSelect(x.value, index);
                                }}
                                options={currentItemData
                                  ?.filter(
                                    (option: any) =>
                                      !selectDepInvDetail.includes(option.id)
                                  )
                                  ?.map((itm: any, index: number) => ({
                                    value: itm?.id,
                                    id: itm?.id,
                                    label: itm.voucherRef?.name,
                                    date: itm?.date,
                                    qty: itm?.qty,
                                    purchasePrice: itm?.price,
                                  }))}
                                optionRender={(itm) => (
                                  <div>
                                    <Row justify={"space-between"}>
                                      <Col>
                                        <p
                                          style={{
                                            fontWeight: "bold",
                                            color: "dimgray",
                                          }}
                                        >
                                          {itm?.label}
                                        </p>
                                      </Col>
                                    </Row>
                                    <div>
                                      {itm.data?.date && (
                                        <span>
                                          <span
                                            style={{
                                              fontWeight: "500",
                                              color: "dimgray",
                                            }}
                                          >
                                            Date -{" "}
                                          </span>
                                          {Utils.getFormattedDate(
                                            itm.data.date
                                          )}
                                        </span>
                                      )}
                                      {itm.data?.qty && (
                                        <span>
                                          <span
                                            style={{
                                              fontWeight: "500",
                                              color: "dimgray",
                                            }}
                                          >
                                            {" "}
                                            Qty -{" "}
                                          </span>
                                          {itm.data?.qty}
                                        </span>
                                      )}
                                      {itm.data?.purchasePrice && (
                                        <span>
                                          <span
                                            style={{
                                              fontWeight: "500",
                                              color: "dimgray",
                                            }}
                                          >
                                            {" "}
                                            Price -{" "}
                                          </span>
                                          {itm.data?.purchasePrice}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                  //   ),
                                  // </Space>
                                )}
                              />
                            </Form.Item>
                          </td>
                          {/* Voucher Date */}
                          <td style={{ width: "12%" }}>
                            <Form.Item name={[name, "date"]} className="m-0">
                              <DatePicker
                                disabled={true}
                                placeholder="Voucher Date"
                                format={"DD/MM/YYYY"}
                                style={{ width: "100%" }}
                                disabledDate={(current) =>
                                  current <
                                  dayjs("1900-01-01", "YYYY-MM-DD").add(
                                    -1,
                                    "day"
                                  )
                                }
                              />
                            </Form.Item>
                          </td>

                          {/* Available Qty. */}
                          <td style={{ width: "7%" }}>
                            <Form.Item
                              name={[name, "availableQty"]}
                              className="m-0"
                            >
                              <InputNumber
                                min={0}
                                disabled={true}
                                placeholder="Available Qty."
                                style={{ width: "100%" }}
                                controls={false}
                                className="inputNumberTextEnd"
                              />
                            </Form.Item>
                          </td>
                          {/* Purchase Price */}
                          <td style={{ width: "10%" }}>
                            <Form.Item
                              name={[name, "purchasePrice"]}
                              className="m-0"
                            >
                              <InputNumber
                                disabled={true}
                                min={0}
                                placeholder="Purchase Price"
                                style={{ width: "100%" }}
                                type="number"
                                controls={false}
                                maxLength={11}
                                className="inputNumberTextEnd"
                              />
                            </Form.Item>
                          </td>

                          {/* Qty. */}
                          <td style={{ width: "7%" }}>
                            <Form.Item
                              name={[name, "qty"]}
                              className="m-0"
                              rules={[
                                {
                                  required: form.getFieldValue([
                                    "items",
                                    index,
                                    "voucherRef",
                                  ])
                                    ? true
                                    : false,
                                  message: "Enter qty",
                                },
                                {
                                  validator: (_, value) => {
                                    const availableQty = form.getFieldValue([
                                      "items",
                                      index,
                                      "availableQty",
                                    ]);
                                    const editTotalQty = form.getFieldValue([
                                      "items",
                                      index,
                                      "editTotalQty",
                                    ]);

                                    // maxAllowedQty decide karo ek hi jagah
                                    const maxAllowedQty = props?.updateId
                                      ? editTotalQty ?? availableQty
                                      : availableQty;

                                    if (value > maxAllowedQty) {
                                      return Promise.reject(
                                        `Max allowed qty is ${maxAllowedQty}`
                                      );
                                    }
                                    return Promise.resolve();
                                  },
                                },
                              ]}
                            >
                              <InputNumber
                                disabled={
                                  props.isLocked || fields.length === index + 1
                                }
                                min={1}
                                // max={
                                //   props?.updateId
                                //     ? form.getFieldValue([
                                //         "items",
                                //         index,
                                //         "editTotalQty",
                                //       ]) ??
                                //       form.getFieldValue([
                                //         "items",
                                //         index,
                                //         "availableQty",
                                //       ])
                                //     : form.getFieldValue([
                                //         "items",
                                //         index,
                                //         "availableQty",
                                //       ])
                                // }
                                placeholder="Qty."
                                style={{ width: "100%" }}
                                controls={false}
                                onChange={() => handleItemsNetAmmount(index)}
                                className="inputNumberTextEnd"
                              />
                            </Form.Item>
                          </td>

                          {/* Sales Price */}
                          <td style={{ width: "10%" }}>
                            <Form.Item
                              name={[name, "sellPrice"]}
                              className="m-0"
                            >
                              <InputNumber
                                min={0}
                                disabled={
                                  props.isLocked || fields.length === index + 1
                                }
                                placeholder="Sales Price"
                                style={{ width: "100%" }}
                                controls={false}
                                onChange={() => handleItemsNetAmmount(index)}
                                className="inputNumberTextEnd"
                              />
                            </Form.Item>
                          </td>
                          {/* Total Price  */}
                          <td style={{ width: "10%" }}>
                            <Form.Item
                              name={[name, "totalAmount"]}
                              className="m-0"
                            >
                              <InputNumber
                                disabled={
                                  props.isLocked || fields.length === index + 1
                                }
                                min={0}
                                placeholder="Total Price"
                                style={{ width: "100%" }}
                                controls={false}
                                onChange={(e: any) => {
                                  console.log("e", e.target?.value);
                                  onItemsTotalAmountChange(index, e);
                                }}
                                className="inputNumberTextEnd"
                              />
                            </Form.Item>
                          </td>
                          {/* Depreciations */}
                          <td style={{ width: "10%" }}>
                            <Form.Item
                              name={[name, "depreciationsAmt"]}
                              className="m-0"
                            >
                              <InputNumber
                                disabled={true}
                                min={0}
                                placeholder="Amount"
                                style={{ width: "100%" }}
                                controls={false}
                                className="inputNumberTextEnd"
                              />
                            </Form.Item>
                          </td>

                          {/* P&L Amt */}
                          <td style={{ width: "10%" }}>
                            <Form.Item
                              name={[name, "pAndLAmt"]}
                              className="m-0"
                            >
                              <InputNumber
                                disabled={true}
                                min={0}
                                placeholder="P&L Amt"
                                style={{ width: "100%" }}
                                controls={false}
                                className="inputNumberTextEnd"
                              />
                            </Form.Item>
                          </td>
                          {/* Delete */}
                          <td style={{ width: "3%" }} align="center">
                            {fields.length !== index + 1 && (
                              <Button
                                onClick={() => {
                                  const getData = form?.getFieldValue([
                                    "batches",
                                    name,
                                  ]);
                                  console.log("getData", getData);

                                  const bNo = getData?.batchNumber;

                                  // const addedBatch = props?.addBatches?.filter(
                                  //   (batchItm: any) =>
                                  //     !bNo.includes(batchItm?.batchNumber)
                                  // );
                                  // setAddBatchNo(addedBatch);
                                  // console.log("addedBatch", addedBatch);
                                  console.log("bNo", bNo);
                                  setSelectDepInvDetail((prev) => {
                                    const newDisabledInputs = [...prev];
                                    newDisabledInputs.splice(name, 1);
                                    return newDisabledInputs;
                                  });
                                  remove(name);
                                  handleAllTheTotalValues();
                                }}
                                type="text"
                                size="small"
                              >
                                <DeleteOutlined style={{ color: "red" }} />
                              </Button>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </>
                );
              }}
            </Form.List>
            <tr>
              <td colSpan={4}>
                <div
                  style={{
                    fontWeight: "bold",
                    // display: "flex",
                    textAlign: "end",
                    // justifyContent: "space-end",
                  }}
                >
                  Sub Total
                </div>
              </td>

              {/* <td>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    Sub Total
                  </div>
                </div>
              </td> */}

              <td
                colSpan={1}
                className="textEnd pe-14"
                style={{ fontWeight: "bold" }}
              >
                {Utils.getFormattedNumber(footerTotal.qty)}
              </td>
              <td></td>
              <td className="textEnd pe-14" style={{ fontWeight: "bold" }}>
                {Utils.getFormattedNumber(footerTotal.amount)}
              </td>

              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </Form>
      <Divider className="ca-model-css" />
    </Modal>
  );
};

export default SelectDisposeAssetItem;
